module.exports = __webpack_public_path__ + "static/media/subscription-success-hourglass.6e61855d.png";